import { render, staticRenderFns } from "./projectSubcontract.vue?vue&type=template&id=480c0d72&scoped=true&"
import script from "./projectSubcontract.vue?vue&type=script&lang=js&"
export * from "./projectSubcontract.vue?vue&type=script&lang=js&"
import style0 from "./projectSubcontract.vue?vue&type=style&index=0&id=480c0d72&prod&scoped=true&lang=scss&"
import style1 from "./projectSubcontract.vue?vue&type=style&index=1&id=480c0d72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c0d72",
  null
  
)

export default component.exports